module.exports = __webpack_public_path__ + "img/boat-5.a1b7fca9.jpg";